import { connect } from 'react-redux';
import { MapLayer, withLeaflet } from 'react-leaflet';
import LeafletPixiOverlay from './LeafletPixiOverlay';
import redrawCallback from './redrawCallback';
import { EVENT_TYPE_AREAS, EVENT_TYPE_SELECTED_AREA } from 'components/Map/ReactLeafletPixiOverlay/event-types';
import { isDrawable, isLodgings, sortByLayerWithDestinationsLast } from 'components/Map/util';
import getStateAwareAreas from 'selectors/map/getStateAwareAreas';

export class ReactLeafletPixiOverlay extends MapLayer {
  static displayName = 'ReactLeafletPixiOverlay';

  componentDidMount() {
    const { areas } = this.props;
    const filteredAreas = [...areas]
      .sort(sortByLayerWithDestinationsLast)
      .filter(a => isDrawable(a) && !isLodgings(a));
    this.layerContainer.addLayer(this.leafletElement);
    this.leafletElement.redraw({ type: EVENT_TYPE_AREAS, payload: { areas: filteredAreas } });
  }

  componentWillUnmount() {
    this.layerContainer.removeLayer(this.leafletElement);
  }

  createLeafletElement(props) {
    return new LeafletPixiOverlay(redrawCallback, { doubleBuffering: false });
  }

  updateLeafletElement(fromProps, toProps) {
    // We only care about the selected area here. (For now.)
    if (fromProps.selectedArea === toProps.selectedArea) {
      return;
    }
    const { selectedArea } = toProps;
    const zoomLevel = this.leafletElement._map.getZoom();
    this.leafletElement.redraw({ type: EVENT_TYPE_SELECTED_AREA, payload: { selectedArea, zoomLevel } });
  }
}


const mapStateToProps = (state) => ({
  areas: getStateAwareAreas(state),
});

export default connect(mapStateToProps)(withLeaflet(ReactLeafletPixiOverlay));